import { Color, Mesh } from 'three';
import { Catenary3D } from '../../catenary-answer';
import { Connection } from '../../connection.model';
import { Simulation } from '../../simulation.model';
import { ConnectionBuilder } from '../object-builders/connection-builder.model';
import GraphicProperties from './graphic-properties.model';

export class ConnectionGraphicProperties extends GraphicProperties {
  color: Color;

  constructor({ color = new Color('#00e2ff') } = {}) {
    super();
    this.color = color;
  }

  updateColor(color: Color): void {}

  async build(riser: Catenary3D, simulation: Simulation, connection: Connection): Promise<Mesh> {
    this.object = await this.getBuilder().build(riser, simulation, connection);
    return this.object;
  }

  getBuilder(): ConnectionBuilder {
    return new ConnectionBuilder();
  }
}
